<div class="bg-galliano relative h-8">
    <!-- Desktop: Show all items in a row -->
    <div class="text-white px-4 py-1 hidden md:flex flex-row flex-nowrap justify-around items-center w-full h-full">
        <div *ngFor="let item of items" class="text-lg uppercase">
            @if (item.link.startsWith('http')) {
                <a [href]="item.link" target="_blank">
                    <span [innerHTML]="item.label"></span>
                </a>
            } @else {
                <a [routerLink]="[item.link]"><span [innerHTML]="item.label"></span></a>
            }
        </div>
    </div>

    <!-- Mobile: Show one item at a time with sliding animation -->
    <div class="text-white px-4 py-1 md:hidden w-full h-full overflow-hidden relative">
        <div
            class="absolute top-0 left-0 flex transition-transform duration-500 ease-in-out"
            [ngStyle]="{ width: (items.length * 100) + '%', transform: 'translateX(-' + (currentIndex() * (100 / items.length)) + '%)' }"
        >
            <div
                *ngFor="let item of items"
                class="flex-1 text-base text-center px-4 py-1 uppercase"
                [ngStyle]="{ width: (100 / items.length) + '%' }"
            >
                @if (item.link.startsWith('http')) {
                    <a [href]="item.link" target="_blank">
                        <span [innerHTML]="item.label"></span>
                    </a>
                } @else {
                    <a [routerLink]="[item.link]"><span [innerHTML]="item.label"></span></a>
                }
            </div>
        </div>
    </div>
</div>
